"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var react_router_dom_1 = require("react-router-dom");

var React = require("react");

var MobileHeader_1 = require("./MobileHeader");

var MobileTabLinkListItem = styled_components_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom: 1px solid #979797;\n"], ["\n  border-bottom: 1px solid #979797;\n"])));
var MobileTabLinkAnchor = styled_components_1.default(react_router_dom_1.NavLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 15px;\n  display: block;\n  color: #fff;\n  text-decoration: none;\n  border-left: 4px solid transparent;\n  &.active {\n    border-left: 4px solid #54bfda;\n  }\n"], ["\n  padding: 15px;\n  display: block;\n  color: #fff;\n  text-decoration: none;\n  border-left: 4px solid transparent;\n  &.active {\n    border-left: 4px solid #54bfda;\n  }\n"])));

var MobileTabLink = function MobileTabLink(props) {
  return React.createElement(MobileTabLinkListItem, null, React.createElement(MobileTabLinkAnchor, {
    to: props.link,
    exact: true,
    onClick: MobileHeader_1.toggleMobileMenu
  }, props.text));
};

exports.default = MobileTabLink;
var templateObject_1, templateObject_2;